import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { IFieldName } from "../../../providers/Pushdown/util/getPushdownError";

export type TErrorState = 'RequiredField' | 'NotValid' | 'ThirdParty'

export type TFieldValidationResult = {
    [ name in IFieldName ] ?: TErrorState
};

export type TFieldValidationFunction =
    | ((validatingState: TAcquisitionProviderFacade) => (TFieldValidationResult))
    | ((validatingState: TAcquisitionProviderFacade) => (Promise<TFieldValidationResult>));

export class ValidationAbortError extends Error {
    pushdownToShow: string;
    constructor (message: string, pushdownToShow?: string) {
        super(message);
        this.pushdownToShow = pushdownToShow;
    }
};
